<template lang="pug">
v-app
  title-bar(v-if="!$route.meta.hideNav")

  v-main
    router-view

  v-footer(app)
    v-layout
      v-btn(text href="/privacy-policy.html") Privacy Policy
      v-spacer
</template>

<script>
  import TitleBar from '../sitewide/TitleBar.vue'
  import { mapGetters } from 'vuex'

  export default {
    components: { TitleBar }
  }
</script>

<style>
  /* ── Light mode: replace all harsh whites with soft greys ──────────────── */

  /* Cards, sheets, dialogs, expansion panels */
  .theme--light.v-card,
  .theme--light.v-sheet,
  .theme--light.v-dialog > .v-card,
  .theme--light.v-expansion-panel {
    background-color: #f4f4f4 !important;
  }

  /* Menus, autocomplete popups */
  .theme--light.v-menu__content,
  .theme--light.v-autocomplete__content.v-menu__content {
    background-color: #efefef !important;
  }

  /* List backgrounds (sidebars, navigation, dropdowns) */
  .theme--light.v-list {
    background-color: #efefef !important;
  }

  /* App bar and toolbars */
  .theme--light.v-app-bar,
  .theme--light.v-toolbar {
    background-color: #e2e2e2 !important;
  }

  /* Data tables */
  .theme--light.v-data-table {
    background-color: transparent !important;
  }
  .theme--light .v-data-table thead th {
    background-color: #e0e0e0 !important;
  }

  /* Text field / input slot backgrounds */
  .theme--light .v-text-field:not(.v-text-field--outlined) .v-input__slot {
    background-color: #efefef !important;
  }

  /* Outlined dropdowns */
  .theme--light .v-select.v-text-field--outlined .v-input__slot {
    background-color: #efefef !important;
  }

  /* Tabs */
  .theme--light.v-tabs-items,
  .theme--light .v-tab-item {
    background-color: transparent !important;
  }

  /* Footer */
  .theme--light.v-footer {
    background-color: #e2e2e2 !important;
  }

  /* ── Dark mode dropdown tint (unchanged) ────────────────────────────────── */
  .theme--dark .v-select.v-text-field--outlined .v-input__slot {
    background-color: rgba(255, 255, 255, 0.08) !important;
  }
</style>
